export default "__VITE_ASSET__DVrKrHPk__"